var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-title',[_vm._v("\n    "+_vm._s(_vm.$t('login.title'))+"\n  ")]),_vm._v(" "),_c('login')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }